module.exports = __webpack_public_path__ + "media/images/niger-8c6e794ffebb32c0e51eb41d57837eed.png";